module.exports = __webpack_public_path__ + "img/web-hosting.bd08c4df.png";